import React, { useContext, useEffect, useRef, useState } from "react";
import { Sorting } from "../../../../../components/Lists/Sorting";
import "./QuoteVendorModal.css";
import { Tag } from "../../../../../components/Tags/Tag";
import { Tooltip } from "@mui/material";
import { QuoteVendorPRNList } from "./QuoteVendorPRNList";
import {
  getVendorQuoteModalList,
  updateFromQuote,
} from "../../../Services/QuoteService";
import {
  QuoteOrderContext,
  QuoteOrderContextProvider,
} from "../../../context/QuoteOrderContext";
import MultioptionButton from "../../../../../components/Buttons/MultioptionButton";
import { set } from "react-hook-form";
import { use } from "react";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import { useSnackBar } from "../../../../../hooks/useSnackBar";

const tagsMapper = {
  success: "Quoted",
  info: "Partially Quoted",
  warning: "Pending",
  issued: "Expired",
};
export const QuoteVendorModalWrapper = (props) => (
  <QuoteOrderContextProvider>
    <QuoteVendorModal {...props} />
  </QuoteOrderContextProvider>
);
const QuoteVendorModal = ({ onClose, quote, setUpdateInfoList }) => {
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [vendorSelected, setVendorSelected] = useState(null);
  const [vendorList, setVendorList] = useState([]);

  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const {
    isOnEdition,
    setIsOnEdition,
    quoteVendorFormState,
    setQuoteVendorFormState,
  } = useContext(QuoteOrderContext);

  const multiOptionsBtn = [
    { label: "Save and Finish", icon: "icon-save", id: "save" },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => saveSection(quoteVendorFormState, true),
    cancel: () => cancelEdit(),
  };

  const cancelEdit = () => {
    setIsOnEdition(false);
  };

  const saveSection = (list, finish) => {
    const result = [];
    if (!list || Object.keys(list).length === 0) {
      setIsOnEdition(false);
      setQuoteVendorFormState(null);
    }
    Object.entries(list).forEach(([prnId, vendors]) => {
      Object.entries(vendors).forEach(([vendorId, values]) => {
        if (values.isOnEdition) {
          result.push({
            id: parseInt(values.id),
            responseDate: new Date(values.responseDate),
            unitCost: parseFloat(values.unitCost),
            taxIncluded: parseFloat(values.taxIncluded),
            leadDays: values.leadDays,
            unitCostdiscountApplied: parseFloat(values.discountApplied),
            currencyId: parseInt(values.currencyId),
          });
        }
      });
    });

    updateFromQuote(result)
      .then((res) => {
        if (res.data.responseCode === 200) {
          successMsg("Quotes were updated successfully.");
          setIsOnEdition(false);
          setQuoteVendorFormState(null);
          setUpdateInfoList(new Date().getTime());
        }
      })
      .catch((err) => {});
  };
  const getSortingOrder = (order) => {
    // setSortingOrder(order);
  };
  const switchedTagsMapper = Object.fromEntries(
    Object.entries(tagsMapper).map(([key, value]) => [value, key])
  );
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
    setLoading(true);
    getVendorQuoteModalList(quote?.id)
      .then((res) => {
        setLoading(false);
        if (res.data.responseCode === 200) {
          const inventoryArray = res.data.load;
          setVendorSelected(inventoryArray[0]);
          setVendorList(inventoryArray);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error fetching vendor quote modal list:", err);
      });
  }, []);
  return (
    <div className="quote-vendor-modal">
      <div className="quote-vendor-modal-header">
        <div className="quote-vendor-modal-header-left-side">
          <div className="header-title">
            <i className="icon-issue"></i>
            <h2>Enter Quote Manually</h2>
          </div>
          <div className="header-part-info">
            <div className="header-part-info-data">
              <p>Cod RFQ</p>
              <b>{quote?.id}</b>
            </div>
            <div className="header-part-info-data">
              <p>Requested By</p>
              <b>{quote?.email}</b>
            </div>
            <div className="header-part-info-data">
              <p>Company</p>

              <b>{quote?.name}</b>
            </div>
          </div>
        </div>
        <div className="quote-vendor-modal-header-right-side">
          <div className="general-info-actions">
            {!isOnEdition && (
              <button
                className="outlined iconTextButton small-size"
                onClick={() => setIsOnEdition(true)}
              >
                <i className="icon-edit"></i>
                <span>Edit</span>
              </button>
            )}
            {isOnEdition && (
              <MultioptionButton
                buttons={multiOptionsBtn}
                buttonCallbacks={buttonsCallback}
              ></MultioptionButton>
            )}
          </div>
          <button className="outlined icon small-size" onClick={onClose}>
            <i className="icon-cross"></i>
          </button>
        </div>
      </div>

      <hr />
      <div className="quote-vendor-modal-content">
        <div className="quote-vendor-modal-content-left-side">
          <div className="sorting-header">
            <div className="sorting-free-slot"> </div>
            <Sorting
              onOrderChange={getSortingOrder}
              ignoreProperties={true}
              displayButton={false}
              initialSort="date_request_required"
              properties={{
                id: "Score",
                part_number: "Vendor",
                required: "Status",
              }}
            ></Sorting>
          </div>
          <div className="quote-vendor-list">
            {loading ? (
              Array.from({ length: 7 }).map((_, idx) => (
                <div key={idx} className="item-container-skeleton">
                  <Skeleton
                    style={{ borderRadius: "10px" }}
                    height="1.68rem"
                    width={40}
                  />
                  <div className="item-skeleton-content">
                    <Skeleton height={20} width="80%" />
                  </div>
                  <Skeleton height={30} width="7rem" />
                </div>
              ))
            ) : vendorList.length === 0 ? (
              <ResultsNotFound />
            ) : (
              vendorList.map((item, idx) => (
                <React.Fragment key={`${item.id}-${idx}`}>
                  <div
                    className={`${
                      vendorSelected?.id == item.id ? "active" : ""
                    }  item-quote-modal-management-container`}
                    onClick={() => setVendorSelected(item)}
                  >
                    {/* <PartImage item={item} /> */}
                    {["score", "vendor_name"].map((label) => (
                      <div
                        className={`property ${
                          label === "totalVendors" ||
                          label === "quoteExpiration"
                            ? "centerItem"
                            : ""
                        }`}
                        key={label}
                      >
                        <Tooltip
                          title={
                            tooltips[`${item.id}-${label}`] ? item[label] : ""
                          }
                          arrow
                        >
                          {label == "score" ? (
                            <div className="score-container">
                              <i className="icon-favorite"> </i>
                              <p
                                className="light-font"
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {item[label]}
                              </p>
                            </div>
                          ) : (
                            <p
                              className="light-font"
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[`${item.id}-${label}`] =
                                    el;
                                }
                              }}
                            >
                              {item[label]}
                            </p>
                          )}
                        </Tooltip>
                      </div>
                    ))}
                    <Tag
                      style={{ width: "9vw" }}
                      tag={item.status}
                      type={switchedTagsMapper[item.status]}
                    ></Tag>
                  </div>
                </React.Fragment>
              ))
            )}
          </div>
        </div>
        <div className="quote-vendor-modal-content-right-side">
          {vendorSelected && (
            <QuoteVendorPRNList
              onClose={onClose}
              vendorInfo={vendorSelected}
              quote={quote}
            />
          )}
        </div>
      </div>
    </div>
  );
};
